import React, { useEffect, useState } from "react";
import { Chip, Grid } from "@mui/material";
import Accordion from "components/common/accordion/Accordion";
import useInsuranceInformation from "../useInsuranceInformation";
import GuarantorInformationItem from "../guarantor/GuarantorInformationItem";

const GuarantorInformationDetail = () => {
  const [guarantorData, setGuarantorData] = useState(null);

  const { newGuarantor } = useInsuranceInformation();

  useEffect(() => {
    if (newGuarantor) {
      setGuarantorData({ ...newGuarantor });
    }
  }, [newGuarantor]);

  return (
    <Accordion
      title={
        <Grid container className="d-flex align-items-center">
          <Grid item xs={11} className="d-flex align-items-center">
            <div className="device-info__device-title">GUARANTOR</div>
            <div className="ml-2">
              <Chip
                color={guarantorData?.active ? "success" : "default"}
                label={
                  <span className="d-flex align-items-center">
                    {guarantorData?.active ? "ACTIVE" : "INACTIVE"}
                  </span>
                }
              />
            </div>
          </Grid>
        </Grid>
      }
      isBordered={false}
      hasPersistentDivider
    >
      <div className="d-flex flex-column">
        <GuarantorInformationItem guarantor={guarantorData} />
      </div>
    </Accordion>
  );
};

export default GuarantorInformationDetail;
